import React, { useContext, useEffect, useRef, useState } from 'react'
import classes from './AddCartPopup.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import BookPage1 from "../../../assets/BookPage4.png";
import BookPage2 from "../../../assets/BookPage3.png";
import BookPage3 from "../../../assets/BookPage2.png";
import BookPage4 from "../../../assets/BookPage1.png";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Swiper, SwiperSlide, Thumbs } from 'swiper/react';

import img from "../../../assets/bookPlaceHolder.png";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import Details from './Details';
import AuthContext from '../../Common/authContext';
import { useDispatch, useSelector } from 'react-redux';
import { addSelectedBook } from '../../redux/productSlice';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const AddCartPopup = () => {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const [selectedBook, setSelectedBook] = useState(null);
  const authCtx = useContext(AuthContext)
  const id = authCtx.addtocartPopupId;
  const isOpen = authCtx.addtocartPopupOpen;
    const fetchBook = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_TESTING_API}/articles?id=${id}&ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
        const book = response.data;
        console.log("Fetched Book:", book);
        setSelectedBook(book);
      } catch (error) {
        // console.error('Error fetching the book:', error);
      }
    };

    useEffect(()=>{
      if (isOpen) fetchBook()
    },[isOpen])

    const styles = {
        style1: {
          position: "absolute",
          top: "50%",
           right: "10%",
          width: "fit-contant",
          height:'fitcontant',
          zIndex: 10,
          rotate:'180deg',
        },
        style2: {
          position: "absolute",
          top: "50%",
           left: "10%",
           width: "fit-contant",
           height:'fitcontant',
          zIndex: 10,
        },
      };
      const [activeSlideIndex, setActiveSlideIndex] = useState(0);
      const [activeId, setactiveId] = useState(1);
      
  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.activeIndex);
  };


  const [swiper, setSwiper] = useState(null);

  const slideTo = (index) => {
    if(swiper) swiper.slideTo(index);
  };

  const handleMouseMove = (e) => {
    const image = e.target;
    const boundingRect = image.getBoundingClientRect();
    
    const x = (e.clientX - boundingRect.left) / boundingRect.width;
    const y = (e.clientY - boundingRect.top) / boundingRect.height;

    image.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  };

  const handleClose = () => {
   authCtx.setaddtocartPopupOpen(false);
  };

  return (
    <>
      {selectedBook && (
        <Modal open={isOpen} onClose={handleClose} aria-labelledby="book-details-modal" aria-describedby="book-details-modal-description">
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        p: 4,
        maxWidth: '90vw',
        width: '90vw',
        maxHeight: '90vh',
        overflowY: 'auto',
      }}>
        <button style={{position:'absolute',top:10,right:20,background:'none',border:'none',fontSize:'2rem',cursor:'pointer',color:'#333',zIndex:10001}} onClick={handleClose}>&times;</button>
        <div className={classes.bookDetails}>
          <div className={classes.bigContainer}>
            <div className={classes.booksContainer}>
              <h1 style={{fontWeight:'700',fontSize:'calc(1rem + 0.3vw)',marginBottom:'1em',textAlign:'center',width:'100%'}}>{selectedBook?.designation}</h1>
              <div className={classes.swiper}>
                <div className={classes.imageContainer} style={{position:'relative',overflow:"hidden"}}>
                  {selectedBook._qte_a_terme_calcule < 1 && (
                    <div style={{cursor:'pointer'}} className={classes.out_of_stock}>
                      <p>{language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}</p>
                    </div>
                  )}
                  <img
                    src={selectedBook.articleimage?.[0]?.link || img}
                    alt="Book Cover"
                    onMouseMove={handleMouseMove}
                  />
                </div>
              </div>
            </div>
            <Details selectedBook={selectedBook} />
          </div>
        </div>
      </Box>
    </Modal>)}
    </>
  )
}

export default AddCartPopup;
